import React from 'react';
import PayPalWrapper from './PayPalWrapper';

const TestPayPal = () => {
    return (
        <div>
            <h1>Test PayPal</h1>
            <PayPalWrapper />
        </div>
    )
}

export default TestPayPal;